import '../assets/scss/index.scss'

import {
  Box,
  Container,
  FormControl,
  FormHelperText,
  InputLabel,
  MenuItem,
  Typography,
  useMediaQuery
} from '@mui/material'
import AllRequestsBtn from '../components/AllRequestsBtn'
import { styled, useTheme } from '@mui/material/styles'
import { useLocation, useNavigate } from 'react-router-dom'
import { PATH } from '../routes/constant'
import Select from '@mui/material/Select'
import * as React from 'react'
import { useEffect, useState } from 'react'
import InputField from '../components/InputField'
import Btn from '../components/Btn'
import { useGetSupportTicketMutation, usePostTicketMutation } from '../redux/api/supportApi'
import useToken from '../hooks/useToken'
import AlertNotification from '../components/AlertNotification/AlertNotification'
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline'
import { useSelector } from 'react-redux'
import Loader from '../components/Loader/Loader'

const Label = styled(InputLabel)(({ theme }) => ({
  color: '#4D5E80',
  fontSize: 14,
  fontWeight: 700,
  marginBottom: '13px'
}))

const SupportCreateTicketsPage: React.FC = (props) => {
  const { state } = useLocation()
  const { subject, reason, description } = state ?? {}
  const supportTicket = useSelector((state: any) => state.supportTicketsState)
  const ticketId = useSelector((state: any) => state.createTicketState)
  const navigate = useNavigate()
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('lg'))
  const { xsrf } = useToken()
  const [page] = useState(1)
  const [countLoop, setCountLoop] = useState(0)
  const [isLoading, setIsLoading] = useState(false)
  const [createReason, setCreateReason] = React.useState(reason || '')
  const [createSubject, setCreateSubject] = useState(subject || '')
  const [createDescription, setCreateDescription] = useState(description || '')
  const [createTicket, { isLoading: isLoadingCreate, isSuccess: isSuccessCreate }] = usePostTicketMutation()
  const [getTicket] = useGetSupportTicketMutation()

  const reasons = [
    { label: 'General Issue', value: 1 },
    { label: 'Facebook Ads', value: 2 },
    { label: 'Billing', value: 3 },
    { label: 'Technical Issues', value: 4 },
    { label: 'CRM', value: 5 },
    { label: 'Go Live', value: 6 },
    { label: 'IDX', value: 7 },
    { label: 'Marketing', value: 8 },
    { label: 'Sales', value: 9 },
    { label: 'Security Issue', value: 10 }
  ]
  useEffect(() => {
    if (isSuccessCreate) {
      setIsLoading(true)
      console.log('lastId', ticketId.lastTicketId)
      console.log('newId', supportTicket.tickets?.data[0]?.id)
      setCountLoop(countLoop + 1)
      if (countLoop > 4) {
        navigate(PATH.SUPPORT)
      } else {
        if ((ticketId.lastTicketId === supportTicket.tickets?.data[0]?.id)) {
          const getTicketTimer = setTimeout(() => {
            getTicket({ page }).then().catch(e => {})
            clearTimeout(getTicketTimer)
          }, 1000)
        } else navigate(PATH.SUPPORT_DETAILS(supportTicket.tickets?.data[0]?.id))
      }
    }
  }, [isSuccessCreate, supportTicket])

  const handleSubmit = async (e: React.MouseEvent<HTMLElement>) => {
    e.preventDefault()
    const reason = reasons.find((reason: any) => reason.value === Number(createReason))
    await createTicket({ reason: reason?.label, subject: createSubject, description: createDescription, token: xsrf })
  }

  if (isLoading) {
    return <Box sx={{ marginTop: '200px' }}><Loader/></Box>
  }

  return (
        <Box sx={{
          px: isMobile ? 2 : 5,
          pb: 3,
          position: 'relative'
        }}>
            {isSuccessCreate && <AlertNotification icon={<CheckCircleOutlineIcon fontSize="inherit" />} text="Success" time={1500}/>}
            <Box onClick={() => {
              navigate(PATH.SUPPORT)
            }} sx={{
              pt: isMobile ? 0 : 3,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              backgroundColor: theme.palette.grey[98],
              zIndex: 1
            }}>
                <AllRequestsBtn/>
            </Box>
            <Typography align='center' variant='h2' sx={{
              color: theme.palette.grey[40],
              fontWeight: 900,
              backgroundColor: theme.palette.grey[98], // #F7F8FA
              zIndex: 2
            }}>New Support Ticket</Typography>

            <Box>
                <Box sx={{
                  mx: isMobile ? 2 : 5,
                  marginTop: isMobile ? '10px' : '20px'
                }}>
                    <Container
                        maxWidth='md'
                        sx={{
                          display: 'flex',
                          flexDirection: 'column',
                          alignContent: 'center',
                          justifyContent: 'center'
                        }}
                        style={{ padding: 0 }}
                    >
                        <Box sx={{
                          paddingBottom: isMobile ? '10px' : '20px'
                        }}>
                            <form>
                                <Label htmlFor='reason-select'>Please Select Your Request Type *</Label>
                                <FormControl fullWidth required>
                                    <Select
                                        id='reason-select'
                                        value={createReason}
                                        fullWidth
                                        onChange={(e) => {
                                          setCreateReason(e.target.value)
                                        }}
                                        sx={{ mb: 3 }}
                                    >
                                        {reasons.map(({ value, label }, index) => (
                                            <MenuItem key={index} value={value}
                                                      sx={{ fontSize: 14, fontWeight: 700 }}>
                                                {label}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                  <FormHelperText></FormHelperText>
                                </FormControl>
                                <Label htmlFor='create-subject'>Subject *</Label>
                                <InputField
                                    id='create-subject'
                                    value={createSubject}
                                    fullWidth
                                    required
                                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                                      setCreateSubject(e.target.value)
                                    }}
                                    sx={{ mb: 3 }}
                                />
                                <Label htmlFor='create-description'>Describe the reason for this ticket *</Label>
                                <InputField
                                    id='create-description'
                                    value={createDescription}
                                    fullWidth
                                    required
                                    multiline
                                    rows={10}
                                    maxRows={10}
                                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                                      setCreateDescription(e.target.value)
                                    }}
                                    sx={{ mb: '35px' }}
                                />
                                <Box sx={{ display: 'flex', justifyContent: 'flex-end', pt: '4px' }} >
                                    <Btn variant= 'contained' color='secondary' text={isLoadingCreate ? 'Loading...' : 'Submit Ticket'}
                                         sx={{ width: 'auto', py: '8px', height: '40px' }}
                                         type='submit'
                                         disabled={(!createReason || !createSubject || !createDescription) || isLoadingCreate}
                                         onClick={handleSubmit}
                                    />
                                </Box>
                            </form>
                        </Box>
                    </Container>
                </Box>
            </Box>
        </Box>
  )
}

export default SupportCreateTicketsPage
